export const handleApiError = async (response) => {
    if (response.status === 413) {
        return new Error('Размер файла слишком большой. Пожалуйста, выберите файл меньшего размера.');
    }

    if (response.status === 401) {
        return new Error('Необходима авторизация');
    }

    let errorMessage = 'Ошибка сервера. Попробуйте позже.';

    try {
        const errorData = await response.clone().json();
        errorMessage = errorData.message || errorMessage;
    } catch (e) {
        try {
            const text = await response.text();
            if (text) errorMessage = text;
        } catch (e) {
            console.error('Не удалось прочитать тело ошибки:', e);
        }
    }

    return new Error(errorMessage);
};

export const handleNetworkError = (error) => {
    if (error.name === 'AbortError') {
        return 'Запрос был отменён';
    }

    if (error.name === 'TypeError' || error.message.includes('Failed to fetch')) {
        return 'Нет соединения с сервером. Проверьте интернет-соединение.';
    }

    return error.message || 'Произошла сетевая ошибка';
};